import React from "react";
import { useStores } from "_common/hooks";
import i18next from "i18next";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { handleCopyLink } from "_common/utils/helper";
import QRCode from "react-qr-code";

export default function MobileInvite() {
  const {
    authStore: { user, logo, general },
  } = useStores();

  return (
    <div className="container !w-[90%] !mt-[50px]">
      <HeaderTop title="Mời" />
      <div className="no_content w-[90%] mx-auto">
        <div className="no_inbox">
          <div className="imgbox">
            <img src={logo} alt="" className="h-[80px]" />
          </div>
          <div className="logobox">
            <div className="w-full h-[30px] leading-[30px] text-center">
              <b className="fe6im text-[22px]">{general?.name_website}</b>
            </div>
          </div>

          <div className="logobox !h-[180px] mt-[10px] ">
            <div className="logobox_left !w-[100%] flex justify-center">
              <div className="w-[150px] h-[150px] mt-[20px]">
                {user.link_ref && (
                  <QRCode
                    size={256}
                    viewBox="0 0 256 256"
                    className="w-[150px] h-[150px]"
                    value={user.link_ref}
                  />
                )}
              </div>
            </div>
          </div>
          <p className="fe6im text-[14px] text-center">Mã lời mời của tôi</p>
          <h2 className="fe6im text-[14px] text-center">{user.ref_no}</h2>
          <div
            onClick={() => handleCopyLink(user.link_ref)}
            className="w-[60%] h-[50px] leading-[50px] text-white text-center bg-[#00b897] m-[10px] mx-auto rounded-[15px]"
          >
            <span className="text-[14px] text-white">
              Sao chép liên kết lời mời
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
